import { render, staticRenderFns, recyclableRender, components } from "./index.vue?vue&type=template&id=3698b146&scoped=true&"
var renderjs
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=3698b146&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@dcloudio/vue-cli-plugin-uni/packages/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3698b146",
  null,
  false,
  components,
  renderjs
)

export default component.exports